'use client';
import { useState } from 'react';
import { SparkleIcon } from './icons';
import { askUrl, ASK_MAX } from '@/lib/askClaude';

/**
 * "Ask Claude" entry points into chat.2factor.finance, styled after 2factor.finance's (amber sparkle, outline
 * button). Every one opens the chat in a new tab with its question already asked.
 */
export function AskClaude({ q, className = 'ask-btn', label = 'Ask Claude' }: { q?: string; className?: string; label?: string }) {
  return (
    // Some sit inside clickable rows (task rows open their modal): keep the click to the link.
    <a className={className} href={askUrl(q)} target="_blank" rel="noopener" title={q} onClick={(e) => e.stopPropagation()}>
      <SparkleIcon />
      {label}
    </a>
  );
}

/**
 * Free-text question box (FAQ). Opens the chat from script rather than submitting the form to it: the CSP's
 * `form-action 'self'` (next.config.ts) blocks a form posting to another origin.
 */
export function AskBox() {
  const [text, setText] = useState('');
  return (
    <form
      className="ask-box"
      onSubmit={(e) => {
        e.preventDefault();
        if (text.trim()) window.open(askUrl(text), '_blank', 'noopener');
      }}
    >
      <input
        className="ask-input"
        value={text}
        maxLength={ASK_MAX}
        placeholder="Type your question"
        aria-label="Your question"
        onChange={(e) => setText(e.target.value)}
      />
      <button type="submit" className="ask-btn" disabled={!text.trim()}>
        <SparkleIcon />
        Ask
      </button>
    </form>
  );
}
